import React from 'react'
import { Link, Outlet } from 'react-router-dom';

const VendorManagement = () => {
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h2>Vendor Management</h2>
          </div>
          <div className="CommonTabs">
            <div className="TitleBox">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <Link to={'Vendors'} className="nav-link active" data-toggle="tab">
                    Vendors
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={'VendorCategories'} className="nav-link" data-toggle="tab">
                    Vendor Categories
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={'VendorCities'} className="nav-link" data-toggle="tab">
                    Vendor Cities
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <Outlet/>
        </div>
      </div>
    </>
  )
}

export default VendorManagement
